import React from "react";
import ReviewList from "../../components/Pages/Reviews/List/List";

const ReviewsList = () => {
  return (
    <div>
      <ReviewList />
    </div>
  );
};

export default ReviewsList;
